import { Injectable } from '@angular/core';
import collect from '@new-core/assets/collect.wav';
import success from '@new-core/assets/success.wav';

/**
 * Service that exposes audio files for.
 */
@Injectable()
export class AudioLibraryService {
  collect = new Audio(collect);
  success = new Audio(success);
}
